import { isEqual } from 'lodash';
import ACTION_TYPES from './actionTypes.constants';
import {
  // INIT_BRANDS,
  // INIT_CATEGORIES,
  // INIT_OFFER_TYPES,
  // INIT_OFFERS,
  INIT_PLATFORMS,
  // OFFER_DETAILS,
} from './initData';

const initialState = {
  platforms: INIT_PLATFORMS,
  offerTypes: [],
  categories: [],
  appliedFilters: {},
  tempAppliedFilters: {},
  brands: {},
  offersList: [],
  filters: {},
  offerDetails: [],
  cid: '',
  imagesLoading: false,
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.PLATFORMS: {
      return {
        ...state,
        platforms: action.payload,
      };
    }
    case ACTION_TYPES.OFFER_TYPES: {
      return {
        ...state,
        offerTypes: action.payload,
      };
    }
    case ACTION_TYPES.APPLIED_FILTERS: {
      if (isEqual(action.payload, state.appliedFilters)) {
        return state;
      }
      return {
        ...state,
        appliedFilters: action.payload,
      };
    }
    case ACTION_TYPES.TEMP_APPLIED_FILTERS: {
      if (isEqual(action.payload, state.tempAppliedFilters)) {
        return state;
      }
      return {
        ...state,
        tempAppliedFilters: action.payload,
      };
    }
    case ACTION_TYPES.OFFERS_LIST: {
      if (isEqual(action.payload, state.offersList)) {
        return state;
      }
      return {
        ...state,
        offersList: action.payload,
      };
    }
    case ACTION_TYPES.FILTERS: {
      if (isEqual(action.payload, state.filters)) {
        return state;
      }
      return {
        ...state,
        filters: action.payload,
      };
    }
    case ACTION_TYPES.BRANDS: {
      if (isEqual(action.payload, state.brands)) {
        return state;
      }
      return {
        ...state,
        brands: action.payload,
      };
    }
    case ACTION_TYPES.OFFER_DETAILS: {
      return {
        ...state,
        offerDetails: action.payload,
      };
    }
    case ACTION_TYPES.CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case ACTION_TYPES.URL_CID: {
      return {
        ...state,
        cid: action.payload,
      };
    }
    case ACTION_TYPES.IMAGES_LAODING: {
      return {
        ...state,
        imagesLoading: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
